import {createFileRoute} from "@tanstack/react-router";
import {parseQuotationsListViewMode} from "~/utilities/ottokart/quotationListViewSwitcher";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/ottokart/_ottokartScaffold/admin/advanced-quotations/")({
    validateSearch: (search: Record<string, unknown>) => ({
        offset: typeof search.offset === "number" ? search.offset : 0,
        limit: typeof search.limit === "number" ? search.limit : 20,
        view: parseQuotationsListViewMode(search.view),
    }),
    loader: async () => {},
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
